import React, { Component } from "react";
import Swal from "sweetalert2";
import discardChanges from "../static/images/svgs/icon/discardChanges.svg";
import "./customStyles.css";

class CancelAction extends Component {
  showPopupCancel() {
    const { onOk, onCancel } = this.props;
    Swal.fire({
      title: "Discard changes",
      text: "Changes will not be saved. Do you want to proceed ?",
      imageUrl: discardChanges,
      showCancelButton: true,
      // confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        popup: "sw-popup",
        htmlContainer: "sw-content",
        confirmButton: "sw-btn-default sw-btn-confirm", //insert class here
        cancelButton: "sw-btn-default sw-btn-cancel",
      },
      preConfirm: () => {
        return onOk();
      },
    });
    return onCancel();
  }

  render() {
    const { openModalCancelAction } = this.props;
    return <div>{openModalCancelAction && this.showPopupCancel()}</div>;
  }
}

export default CancelAction;
